/**Function for determinig if arrays have the same length property. Substituting 'array: any[]' in favor of Array<T = unknown>
 * https://betterprogramming.pub/4-ways-to-replace-any-in-typescript-5470b8d8357d
 * @params array1[], array2[]
 * @return boolean
 **/
export const areLengthsEqual = (array1: unknown[], array2: unknown[]): boolean => {
  return array1.length === array2.length;
};